import { gql } from '@apollo/client';

export const GET_PUBLISHER_MEMBERSHIP_INVITES = gql`
  query membershipsPublisherInvite($input: MembershipSearchInput!) {
    membershipsPublisherInvite(input: $input) {
      count
    }
  }
`;
